import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UserService } from '@core/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { KeysEstaticas } from '@shared/constantes/KeysStaticas';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'area_privada';
  readonly SESSION_IDIOMA = KeysEstaticas.SESSION_IDIOMA;
  constructor(
    private translate: TranslateService,
    private userService: UserService
  ) { }

  ngOnInit() {
    const idioma = sessionStorage.getItem(this.SESSION_IDIOMA) || this.userService.getIdioma();
    const lang = idioma;
    this.translate.setDefaultLang(lang!);
    this.translate.use(lang!);
  }

}
